<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />
      <CSRSidebarMenu v-if="csr == true" />
        <div class="content-wrapper">
          <div class="container-wrapper center">

          <div>

            <div class="form_row">
              <div class="form_col_1">
                <h3 class="d-inline heading">{{ pageHeading }}</h3>
              </div>
              <div class="form_col_2">
                <div class="float-right scroll_box cursor-pointer">
                  <span class="scroll_up_down" @click="scrollToElement('down')">
                    <i class="fa fa-angle-down angle_font"></i>
                  </span>
                </div>
              </div>
            </div>
            
            <div class="heading-seperator"></div>
              <div class="float-left col-md-10 col-12 override-padding" style="font-size: 16px;">
                <div class="text-align-center" style="padding-top: 7px;">
                  {{ sub_tasklist_obj.tasklist.name }}
                  <i @click="editTaskListModalAction()" class="cursor-pointer fa fa-pencil-square-o" style="font-size: 15px !important;" aria-hidden="true" ></i>
                </div>

              </div>
              <div class="float-right col-md-2 col-12 override-padding" style="padding-top: 5px;">
              <button
                  v-if="addSubtaskShow === false"
                  v-on:click="addSubtaskShow = true"
                  class="btn btn-red btn-md input-height-15 float-right text-align-right"
                  ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Sub Task</button>
              </div>
              <div style="clear: both" ></div>
            <div class="heading-seperator" style="margin-top: 5px;"></div>
          </div>
          <div style="clear: both" class="margin-bottom-5"></div>
          <div class="margin-bottom-5">Sub-task Lists:</div>
          <div class="col-12 override-padding">
          <div class="task-list-summary float-left col-10 override-padding" style="padding-top: 1px;">
            <span>Tasks List Summary:</span> <span style="padding-left: 25px;">{{ subtaskCount }} Sections</span> <span style="padding-left: 25px;">{{ headingsCount }} Sub Sections</span> <span style="padding-left: 25px;">{{ tasksCount }} Tasks</span>
          </div>

          <div
            v-if="this.sub_tasklist_obj.sub_tasklists_lists.length > 0"
            class="submit float-right col-2 override-padding" @click="onSubmit">
            <button type="submit" class="col-12 btn btn-red btn-md col-12 input-height-15">Save List</button>
          </div>
          </div>
          <div style="clear: both" class="margin-bottom-10"></div>
          <div
            class="subtaskadd col-12 override-padding"
            v-if="addSubtaskShow === true">
            <div class="col-lg-10 col-sm-9 col-12 float-left override-padding" style="padding-right: 5px;">
              <input
                  v-model="sub_tasklists"
                  type="text"
                  name="sub_tasklists"
                  id="sub_tasklists"
                  ref="sub_tasklists"
                  placeholder="Enter Sub-Tasklist Title"
                  class="col-12 input-height-25"
                  maxlength="255" />
            </div>
            <div class="col-lg-2 col-sm-3 col-12 float-right override-padding text-align-right">
              <button
                  v-on:click="addSubtasksAction"
                  class="btn btn-red save-button-width btn-md input-height-15"
                  ><b>Save</b></button>
              <i class="cursor-pointer fa fa-times" style="padding-left: 10px;" aria-hidden="true" @click="closeAddSubtaskInput()"></i>
            </div>
            <div style="clear: both" ></div>
          </div>

          <div class="subtask_list">
            <ul v-sortable="{onEnd: reorderSubtask, handle: '.handle1'}" class="counter_subtask-list list-group col-lg-12 override-padding margin-bottom-10">
              <li class="list-group-item input-height-25" v-for="(sub_tasklist, subTaskIndex) in sub_tasklist_obj.sub_tasklists_lists" :key="sub_tasklist.sortid">
                <div class="subtask_item" >
                  <div class=" float-left" style="width: 54.66%;">
                    <div v-if="sub_tasklist.edit" class="float-left col-12 override-padding" >
                      <input v-model="sub_tasklist.name"
                          class="col-lg-10 input-height-20"
                          maxlength="255" />
                      <button
                          v-on:click="updateSubtasksAction(sub_tasklist)"
                          class="btn btn-red btn-md input-height-15"
                          ><b>Save</b></button>
                    </div>
                    <div v-else class="handle1 float-left override-padding col-12" style="padding-top: 2px;">
                      <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                      <span class="counter_subtask-list__counter"></span>
                      {{ sub_tasklist.name }} <i @click="sub_tasklist.edit = true;" class="cursor-pointer fa fa-pencil-square-o" aria-hidden="true" ></i>
                    </div>
                  </div>
                  <div v-if="sub_tasklist.tasks.length > 0" class="float-left font-15  text-center override-padding" style="width: 8.33%">
                    Rep Goals
                  </div>
                  <div v-if="sub_tasklist.tasks.length > 0" class="float-left font-15 text-center override-padding" style="width: 8.33%">
                    Rep Time
                  </div>
                  <div v-if="sub_tasklist.tasks.length > 0" class="float-left font-15 text-center override-padding" style="width: 8.33%">
                    Total Time
                  </div>
                  <div class=" float-right override-padding text-align-right" style="width: 19.33%;">
                    <span
                      v-if="sub_tasklist.tasks_count > 0"
                      style="color: #007BFF; padding-right: 1px; font-size: 15px;">(Tasks: {{ sub_tasklist.tasks_count }})</span>
                    <button
                        v-if="sub_tasklist.addHeadingButtonShow === true"
                        v-on:click="HeadingClick(sub_tasklist)"
                        class="btn btn-red save-button-width btn-md input-height-15"
                        ><i class="fa fa-plus" aria-hidden="true"></i> Header</button>
                    <button
                        v-if="sub_tasklist.addTaskButtonShow === true"
                        v-on:click="TaskClick(sub_tasklist, subTaskIndex)"
                        class="btn btn-red save-button-width btn-md input-height-15"
                        ><i class="fa fa-plus" aria-hidden="true"></i> Task</button>
                    <i class="cursor-pointer fa fa-times" v-if="sub_tasklist_obj.tasklist.status == 'DRAFT'" style="padding-left: 10px;" aria-hidden="true" @click="deleteSubTaskConfirm(subTaskIndex)"></i>
                  </div>
                  <div style="clear: both"></div>
                </div>
                <div
                  class="heading_container"
                  :class="sub_tasklist.headings.length > 0 ? 'margin-bottom-5' : ''"
                  >
                  <div
                    class="headingadd col-12 override-padding"
                    v-if="sub_tasklist.addHeadingShow === true">
                    <div class="col-lg-10 col-sm-9 col-12 float-left override-padding" style="padding-right: 5px;">
                      <input
                        v-model="sub_tasklist.headingTitle"
                        type="text"
                        placeholder="Enter Header"
                        class="col-lg-12 input-height-25"
                        maxlength="255" />
                    </div>
                    <div class="col-lg-2 col-sm-3 col-12 float-right override-padding text-align-right">
                        <button
                            v-on:click="addHeadingsAction(sub_tasklist, subTaskIndex)"
                            class="btn btn-red save-button-width btn-md input-height-15"
                            ><i class="fa fa-plus" aria-hidden="true"></i> Save</button>
                        <i class="cursor-pointer fa fa-times" style="padding-left: 10px;" aria-hidden="true" @click="closeAddHeadingInput(subTaskIndex)"></i>
                    </div>
                    <div style="clear: both" ></div>
                  </div>


                  <div v-if="sub_tasklist.tasks.length === 0" class="heading_list">
                    <ul
                      v-sortable="{onEnd: reorderSubtaskHeading, handle: '.handle2', group: { name: 'subtask-' + subTaskIndex, put: createHeaderGroupArray() } }"
                      class="counter_heading-list list-group col-lg-12 override-padding" :data-id="subTaskIndex">
                      <li class="list-group-item input-height-25" v-for="(heading, headingIndex) in sub_tasklist.headings" :key="heading.sortid">
                        <div class="heading_item">
                          <div v-if="heading.edit" class="float-left  override-padding" style="width: 53.66%">
                            <input v-model="heading.name"
                                class="col-lg-8 col-sm-8 col-8 input-height-25"
                                maxlength="255" />
                            <button
                                v-on:click="updateHeadingsAction(heading)"
                                class="btn btn-red btn-md input-height-15"
                                ><b>Save</b></button>
                          </div>
                          <div v-else class="handle2 float-left  override-padding" style="width: 53.66%; padding-top: 2px;">
                            <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                            <span class="counter_heading-list__counter"></span>
                            {{ heading.name }} <i @click="heading.edit = true;" class="cursor-pointer fa fa-pencil-square-o" aria-hidden="true" ></i>
                          </div>
                          <div v-if="heading.tasks.length > 0" class="float-left font-15  text-center override-padding" style="width: 8.33%">
                            Rep Goals
                          </div>
                          <div v-if="heading.tasks.length > 0" class="float-left font-15 text-center override-padding" style="width: 8.33%">
                            Rep Time
                          </div>
                          <div v-if="heading.tasks.length > 0" class="float-left font-15 text-center override-padding" style="width: 8.33%">
                            Total Time
                          </div>
                          <div class="float-right font-15  text-align-right override-padding" style="width: 16.33%">
                            <button
                                v-on:click="choose_tasks_redirect(subTaskIndex, headingIndex)"
                                class="btn save-button-width btn-red btn-md input-height-15"
                                ><i class="fa fa-plus" aria-hidden="true"></i> Task</button>
                            <i class="cursor-pointer fa fa-times" v-if="sub_tasklist_obj.tasklist.status == 'DRAFT'" style="padding-left: 10px;" aria-hidden="true" @click="deleteHeadingConfirm(subTaskIndex, headingIndex)"></i>
                          </div>
                          <div style="clear: both"></div>
                        </div>
                        <div
                          class="task_container"
                          :class="[(heading.tasks.length > 0) ? 'margin-bottom-5 task_container_padding' : '', , ((parseInt(headingIndex) + parseInt(1)) === sub_tasklist.headings.length) ? 'margin-bottom-0' : '']"
                          >
                          <div style="clear: both"></div>
                          <div class="task_list">
                            <ul v-sortable="{onEnd: reorderSubtaskTask, handle: '.handle3', group: { name: 'heading-' + subTaskIndex + '-' + headingIndex, put: createTaskGroupArray() } }" class="counter_task-list tasks_list list-group col-lg-12"  :data-id="subTaskIndex + '-' + headingIndex" style="padding-right: 0;">
                               <li class="list-group-item input-height-25" v-for="(task, taskIndex) in heading.tasks" :key="task.sortid">
                                 <div class="task_item">
                                   <div class="handle3 float-left  override-padding" style="width: 54.33%">
                                    <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                                    <span class="counter_task-list__counter"></span>
                                    {{ task.name }}
                                   </div>
                                   <div class="float-left override-padding" style="width: 8.33%">
                                    <input v-model="task.defaultRepCount"
                                    :id="'rep_count_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex"
                                    class="  default-hours-height"
                                    maxlength="5" 
                                    placeholder="0"
                                    @keyup="calculateTotalHours(subTaskIndex, headingIndex, taskIndex)" 
                                    @blur="onBlurDefaultGoalEvent(subTaskIndex, headingIndex, taskIndex)"
                                    style="width: 69%;"/>
                                   </div>
                                   <div class="float-left override-padding" style="width: 8.33%">
                                    <input v-model="task.defaultRepHours"
                                    :id="'rep_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex"
                                    class="default-hours-height"
                                    maxlength="5" placeholder="0" @keyup="calculateTotalHours(subTaskIndex, headingIndex, taskIndex)" 
                                    @blur="onBlurDefaultGoalEvent(subTaskIndex, headingIndex, taskIndex)"
                                    style="width: 69%;" />
                                   </div>
                                   <div class="float-left override-padding" style="width: 8.33%">
                                    <input v-model="task.defaultTotalRepHours"
                                    :id="'total_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex"
                                    class=" default-hours-height readonly" placeholder="0"
                                    readonly="readonly"
                                    style="width: 69%;"
                                    maxlength="5" />
                                   </div>
                                   <div class="float-left override-padding text-center" style="width: 8.33%">
                                    &nbsp;
                                   </div>
                                   <div class="float-left font-15  override-padding text-align-right" style="width: 12.33%">
                                   <span v-if="task.priority > 0" style="padding-right: 40px;">
                                      P{{ task.priority }}
                                   </span>
                                   <span v-else>&nbsp;</span>

                                   <i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteTaskConfirm(subTaskIndex, headingIndex, taskIndex)"></i></div>
                                 </div>
                                 <div style="clear: both"></div>
                               </li>
                             </ul>
                         </div>
                       </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  v-if="sub_tasklist.headings.length === 0"
                  class="subtask_task_container subtask_task_container_padding"
                  :class="[(sub_tasklist.tasks.length > 0) ? 'margin-bottom-5 ' : '', (sub_tasklist.tasks.length === 0) ? 'backgroud-none subtask_task_container_padding2' : '']" style="padding-right: 0;"
                  >
                  <div class="subtask_task_list">
                    <ul v-sortable="{onEnd: reorderSubtaskTask, handle: '.handle4', group: { name: 'task-' + subTaskIndex, put: createTaskGroupArray() }}" class="counter_task-list col-lg-12" :data-id="subTaskIndex + '-null'">
                       <li class="list-group-item input-height-25" v-for="(task, taskIndex) in sub_tasklist.tasks"  :key="task.sortid">
                         <div class="task_item">
                           <div class="handle4 float-left  override-padding" style="width: 53.33%;">
                            <i class="fa fa-arrows padding-right-5" aria-hidden="true"></i>
                            <span class="counter_task-list__counter"></span>
                            {{ task.name }}
                           </div>
                           <div class="float-left override-padding text-center" style="width: 8.33%">
                            <input 
                            :id="'rep_count_' + subTaskIndex + '-' + taskIndex"
                            v-model="task.defaultRepCount"
                            class="  default-hours-height"
                            maxlength="5" style="width: 69%" placeholder="0" @keyup="calculateTotalHours(subTaskIndex, 'null', taskIndex)" @blur="onBlurDefaultGoalEvent(subTaskIndex, 'null', taskIndex)" />
                           </div>
                           <div class="float-left override-padding text-center" style="width: 8.33%">
                            <input v-model="task.defaultRepHours"
                            :id="'rep_hours_' + subTaskIndex + '-' + taskIndex"
                            class="default-hours-height"
                            maxlength="5" style="width: 69%" placeholder="0" @keyup="calculateTotalHours(
                            subTaskIndex, 'null', taskIndex)" @blur="onBlurDefaultGoalEvent(subTaskIndex, 'null', taskIndex)" />
                           </div>
                           <div class="float-left override-padding text-center" style="width: 8.33%">
                            <input v-model="task.defaultTotalRepHours"
                            :id="'total_hours_' + subTaskIndex + '-' + taskIndex"
                            class="default-hours-height readonly"
                            readonly="readonly" placeholder="0" 
                            style="width: 69%"
                            maxlength="5" />
                           </div>

                           <div class="float-left  override-padding text-center" style="width: 8.33%;">
                            &nbsp;
                           </div>
                           <div class="float-left font-15 override-padding text-align-right" style="width: 13.33%;">
                             <span v-if="task.priority > 0" style="padding-right: 40px;">
                                P{{ task.priority }}
                             </span>
                             <span v-else>&nbsp;</span>
                             <i class="cursor-pointer fa fa-times" aria-hidden="true" @click="deleteTaskConfirm(subTaskIndex, 'null', taskIndex)"></i>
                           </div>
                         </div>
                         <div style="clear: both"></div>
                       </li>
                     </ul>
                   </div>
                 </div>

              </li>
            </ul>
          </div>

          <div style="clear: both" class="margin-bottom-20"></div>
          <div class="task-list-summary float-left col-10 override-padding">
            <span>Tasks List Summary:</span> <span style="padding-left: 25px;">{{ subtaskCount }} Sections</span> <span style="padding-left: 25px;">{{ headingsCount }} Sub Sections</span> <span style="padding-left: 25px;">{{ tasksCount }} Tasks</span>
          </div>

          <div
            v-if="this.sub_tasklist_obj.sub_tasklists_lists.length > 0"
            class="submit float-right col-2 override-padding" @click="onSubmit">
            <button type="submit" class="col-12 btn btn-red btn-md col-12 input-height-15">Save List</button>
          </div>
          <div style="clear: both" ></div>
          	
          <div style="clear: both" class="margin-bottom-10"></div>


            <div class="page_angle_down page_to_down">
              <div class="scroll_box cursor-pointer">
                <span class="scroll_up_down" @click="scrollToElement('up')">
                  <i class="fa fa-angle-up angle_font"></i>
                </span>
              </div>
            </div>

        </div>

        <EditTasklistModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading"><h3>Update Tasklist</h3></div>
          <div slot="body">
            <div class="col-11 override-padding">
              <input v-model="edit_tasklist_title"
                    name="edit_tasklist_title"
                    placeholder="Enter Tasklist Title"
                    class="col-lg-11 input-height-25"
                    v-validate="'required'"
                    maxlength="255" />
              <div v-if="verrors.firstByRule('edit_tasklist_title', 'required')" class="margin-bottom-5 validate-warning-msg">Tasklist title is required</div>
            </div>
            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-11 override-padding" style="display:flex;">
              <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username) && (this.sub_tasklist_obj.tasklist.public == '1'))"
                class="search-padd" 
                id="affliate-wrapper" 
                style="height: 30px;width: 74%;">
                <multiselect v-model="edit_affiliate"
                  :options="affiliate_options"
                  track-by="value"
                  label="text"
                  placeholder="Select Affiliate"
                  :multiple="true"
                  :close-on-select="false"
                  :show-labels="false"
                  v-bind:name="'edit_affiliate[]'"
                  v-bind:id="'edit_affiliate'"
                  v-validate="'required'">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
                </multiselect>
                <div v-if="verrors.firstByRule('edit_affiliate[]', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>
              </div>
              <button
                  v-on:click="editTaskListAction()"
                  class="btn btn-red col-lg-2 col-sm-2 col-3 input-height-25 createBtn"
                  ><b>Update</b></button>

            </div>
            <div v-if="verrors.firstByRule('edit_affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affiliate is required</div>

          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </EditTasklistModal>

        <DeleteModal :isModalVisible="isModalVisible" :id="id" :parent_id="parent_id" @close="isModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{ deleteMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isModalVisible = false; deleteAction()">Confirm</button>
          </div>
        </DeleteModal>

        <ValidationModal :isModalVisible="isValidationModalVisible" @close="isValidationModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">{{ validationMessage }}</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </ValidationModal>

      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import SubTaskList from '../admin/subtask_list.vue';
import axios from 'axios';
import router from '../../router/index.js';
import store from '../../store/store.js';
import ValidationModal from '../shared/validation_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import Sortable from 'sortablejs';
import EditTasklistModal from '../admin/create-tasklist-modal.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import CSRSidebarMenu from '../shared/csr_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.directive('sortable', {
  inserted: function (el, binding) {
    var sortable = new Sortable(el, binding.value || {});
  }
});

export default {
        data() {
          return {
            sub_tasklists: '',
            sub_tasklists_data: {
              sub_tasklists_lists: [],
              tasklist: [],
            },
            isModalVisible: false,
            isEditModalVisible: false,
            subtaskIndexValue: '',
            headingIndexValue: '',
            taskIndexValue: '',
            deleteList: '',
            deleteMessage: '',
            id: '',
            parent_id: '',
            loading: false,
            isValidationModalVisible: false,
            validationMessage: '',
            masterAdmin: false,
            admin: false,
            addSubtaskShow: false,
            sub_tasklist_obj: {
              sub_tasklists_lists: [],
              tasklist: [],
              remove_subtask: [],
              remove_headings: [],
              remove_tasks: [],
              subtask_sort_flag: false,
              subtaskheading_sort_subtaskId: [],
              headingtask_sort_headingId: [],
              subtaskupdate: false,
              modifiedTasksDefaultGoal:[],
            },
            edit_affiliate: [],
            edit_tasklist_title: '',
            affiliate_options: [],
            edit_tasklist_id: '',
            pageHeading: '',
            content: '',
            subtaskCount: 0,
            headingsCount: 0,
            tasksCount: 0,
            researcher: false,
          }
        },
        components: {
          UserMenu,
          GoBack,
          DeleteModal,
          SubTaskList,
          ValidationModal,
          MasteradminSidebarMenu,
          EditTasklistModal,
          AdminSidebarMenu,
          Multiselect,
          CSRSidebarMenu,
        },
        methods: {
          onBlurDefaultGoalEvent(subTaskIndex, headingIndex, taskIndex) {
            if(headingIndex === 'null') {
              var task_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].id;
              var index = -1;
              if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
                index = this.sub_tasklist_obj.modifiedTasksDefaultGoal.findIndex(item => item.id === task_id);
              }
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' + subTaskIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              var rep_hours = document.getElementById(rep_hours_id).value;
              var total_hours = document.getElementById(total_hours_id).value;
              if(index < 0) {
                this.sub_tasklist_obj.modifiedTasksDefaultGoal.push({
                  id: task_id,
                  rep_count: rep_count,
                  rep_hours: rep_hours,
                  total_hours: total_hours,
                });
              }
              else {
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_count = rep_count;
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_hours = rep_hours;
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].total_hours = total_hours;
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else {
              var task_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].id;
              var index = -1;
              if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
                index = this.sub_tasklist_obj.modifiedTasksDefaultGoal.findIndex(item => item.id === task_id);
              }
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              var rep_hours = document.getElementById(rep_hours_id).value;
              var total_hours = document.getElementById(total_hours_id).value;
              if(index < 0) {
                this.sub_tasklist_obj.modifiedTasksDefaultGoal.push({
                  id: task_id,
                  rep_count: rep_count,
                  rep_hours: rep_hours,
                  total_hours: total_hours,
                });
              }
              else {
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_count = rep_count;
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].rep_hours = rep_hours;
                this.sub_tasklist_obj.modifiedTasksDefaultGoal[index].total_hours = total_hours;
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
          },
          calculateTotalHours(subTaskIndex, headingIndex, taskIndex) {
            if(headingIndex === 'null') {
              var total_hours = 0;
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' +  subTaskIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;
              if(rep_count == 0) {
                document.getElementById(rep_count_id).value = '';
              }

              var rep_hours = document.getElementById(rep_hours_id).value;
              if(rep_hours == 0) {
                document.getElementById(rep_hours_id).value = '';
              }

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultRepCount = rep_count.replace(/[^0-9]/g, '');
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultRepHours = rep_hours.replace(/[^0-9]/g, '');

              if((rep_count > 0) && (rep_hours > 0)) {
                total_hours = rep_count * rep_hours;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].tasks[taskIndex].defaultTotalRepHours = total_hours;
            }
            else {
              var total_hours = 0;
              var rep_count_id = 'rep_count_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_hours_id = 'rep_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var total_hours_id = 'total_hours_' + subTaskIndex + '-' + headingIndex + '-' + taskIndex;
              var rep_count = document.getElementById(rep_count_id).value;

              var rep_hours = document.getElementById(rep_hours_id).value;

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultRepCount = rep_count.replace(/[^0-9]/g, '');

              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultRepHours = rep_hours.replace(/[^0-9]/g, '');

              if((rep_count > 0) && (rep_hours > 0)) {
                total_hours = rep_count * rep_hours;
              }
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings[headingIndex].tasks[taskIndex].defaultTotalRepHours = total_hours;
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          calculateTaskListsSummary() {
            var SubtasksCount = 0;
            var HeadingsCount = 0;
            var TasksCount = 0;
            for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
              SubtasksCount = parseInt(SubtasksCount + 1);
              for(var x=0; x < this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length; x++) {
                HeadingsCount = parseInt(HeadingsCount + 1);
                for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks.length; c++) {
                  TasksCount = parseInt(TasksCount + 1);
                }
              }
              for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                TasksCount = parseInt(TasksCount + 1);
              }
            }
            this.subtaskCount = SubtasksCount;
            this.headingsCount = HeadingsCount;
            this.tasksCount = TasksCount;

          },
          editTaskListAction() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                if((!this.masterAdmin) || (this.$store.state.switch_admin_username) || (this.sub_tasklist_obj.tasklist.public != '1')) {
                  this.edit_affiliate = [];
                }
                axios('/checkTasklistsAssignment/' + this.$route.params.task_list_id,
                   {
                      method: 'POST',
                      data:
                      {
                        modifiedAffiliateId: this.edit_affiliate,
                      },
                   }
                 )
                .then((resp) => {
                    var taskListAssignmentFlag = resp.data;
                    if(taskListAssignmentFlag == 1) {
                      this.validationMessage = "Affiliate can't be changed because this tasklists is assigned to groups or mentee/student.";
                      this.isValidationModalVisible = true;
                    }
                    else {
                      axios('/tasklist/' + this.$route.params.task_list_id,
                         {
                           method: 'PATCH',
                           data:
                            {
                              name: this.edit_tasklist_title,
                              affiliate_selected: this.edit_affiliate,
                            },
                         }
                       )
                      .then((resp) => {
                          this.edit_tasklist_title = '';
                          this.edit_affiliate = '';
                          this.edit_tasklist_id = '';
                          this.isEditModalVisible = false;
                          this.loadSubTaskListsAction(this.$route.params.task_list_id);
                       })
                      .catch(error => {
                        if(error.response.data.code == '404') {
                          router.push("/view-tasklist");
                        }
                      });

                    }
                 })
                .catch(error => {

                });

                return false;



              }
            })
            .catch(() => {

            });
          },
          editTaskListModalAction: function() {
            this.edit_tasklist_title = this.sub_tasklist_obj.tasklist.name;
            this.edit_affiliate = this.sub_tasklist_obj.tasklist.affiliate;
            this.edit_tasklist_id = this.sub_tasklist_obj.tasklist.id;
            this.isEditModalVisible = true;
          },
          closeAddSubtaskInput: function() {
            this.addSubtaskShow = false;
          },
          closeAddHeadingInput: function(subTaskIndex) {
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addHeadingShow = false;
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addHeadingButtonShow = true;
            if(this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.length === 0) {
              this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].addTaskButtonShow = true;
            }
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          
          updateDefaultGoalAction: function() {
            if(this.sub_tasklist_obj.modifiedTasksDefaultGoal.length > 0) {
              for(var k=0; k<this.sub_tasklist_obj.modifiedTasksDefaultGoal.length; k++) {
                var task_id = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].id;
                var rep_count = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].rep_count;
                var rep_hours = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].rep_hours;
                var total_hours = this.sub_tasklist_obj.modifiedTasksDefaultGoal[k].total_hours;

                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
                  for(var x=0; x < this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length; x++) {
                    for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks.length; c++) {
                      if(task_id == this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].id) {
                        this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].defaultRepCount = rep_count;
                        this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].defaultRepHours = rep_hours;
                        this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].defaultTotalRepHours = total_hours;
                      }  
                    }
                  }
                  for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                    if(task_id == this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].id) {
                      this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].defaultRepCount = rep_count;
                      this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].defaultRepHours = rep_hours;
                      this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].defaultTotalRepHours = total_hours;
                    }  
                  }
                }
              }
            }
          },
          onSubmit () {
            this.updateDefaultGoalAction();
            setTimeout(() => {
            this.sub_tasklist_obj.subtaskupdate = false;
            axios('/sub-tasklists',
               {
                 method: 'POST',
                 data: {
                    "sub_tasklist_obj": this.sub_tasklist_obj,
                 },
               })
            .then((resp) => {
                this.$store.dispatch('subtasks', '');
                this.$store.dispatch('tasklist_title', '');
                if((this.$store.state.page_url) && 
                    ((this.$store.state.page_url.indexOf('account-lookup') > -1) 
                    || (this.$store.state.page_url.indexOf('account-lookup-detail') > -1) 
                    || (this.$store.state.page_url.indexOf('enterprise-lookup') > -1) 
                    || (this.$store.state.page_url.indexOf('enterprise-lookup-detail') > -1))
                  ) {
                  router.push(this.$store.state.page_url);
                }
                else {
                  router.push("/view-tasklist");
                }

             })
            .catch(error => {

            });
            }, 1000);
          },
          addSubtasksAction: function() {
            if(this.sub_tasklists === '') {
              this.validationMessage = 'Please enter Sub-task title';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            var sub_tasklists_lists_len = this.sub_tasklist_obj.sub_tasklists_lists.length + 1;
            this.sub_tasklist_obj.sub_tasklists_lists.push({
              id: '',
              name: this.sub_tasklists,
              edit: false,
              update: false,
              modified: false,
              sortid: 'subtask-' + sub_tasklists_lists_len,
              addHeadingShow: false,
              addHeadingButtonShow: true,
              addTaskButtonShow: true,
              headingTitle: '',
              headings: [],
              tasks: [],
              tasks_count: 0,
            });
            this.sub_tasklists = '';
            this.sub_tasklist_obj.subtask_sort_flag = true;
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            this.addSubtaskShow = false;
          },
          updateSubtasksAction: function(sub_tasklist) {
            if(sub_tasklist.name === '') {
              this.validationMessage = 'Please enter Sub-task title';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            if(sub_tasklist.update === true) {
              sub_tasklist.modified = true;
            }
            sub_tasklist.edit = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);

          },
          addHeadingsAction: function(sub_tasklist, subTaskIndex) {
            if(sub_tasklist.headingTitle === '') {
              this.validationMessage = 'Please enter header';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            var subtask_sort_id = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].sortid;
            var heading_len = this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.length + 1;
            this.sub_tasklist_obj.sub_tasklists_lists[subTaskIndex].headings.push({
              id: '',
              name: sub_tasklist.headingTitle,
              edit: false,
              update: false,
              modified: false,
              sortid: subtask_sort_id + '-heading-' + heading_len,
              tasks: [],
            });
            sub_tasklist.headingTitle = '';
            sub_tasklist.addHeadingButtonShow = true;
            sub_tasklist.addHeadingShow = false;
            this.sub_tasklist_obj.subtask_sort_flag = true;
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          updateHeadingsAction: function(heading) {
            if(heading.name === '') {
              this.validationMessage = 'Please enter header';
              this.isValidationModalVisible = true;
              return false;
            }
            this.sub_tasklist_obj.subtaskupdate = true;
            if(heading.update === true) {
              heading.modified = true;
            }
            heading.edit = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          choose_tasks_redirect: function (subtaskIndex, headingIndex) {
            this.sub_tasklist_obj.subtaskupdate = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/choose-tasks/" + subtaskIndex + "/" + this.$route.params.task_list_id + "/" + headingIndex);
          },
          HeadingClick: function(sub_tasklist) {
            sub_tasklist.addHeadingButtonShow = false;
            sub_tasklist.addHeadingShow = true;
            sub_tasklist.addTaskButtonShow = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          TaskClick: function(sub_tasklist, subtaskIndex) {
            sub_tasklist.addTaskButtonShow = true;
            sub_tasklist.addHeadingButtonShow = false;
            sub_tasklist.addHeadingShow = false;
            this.sub_tasklist_obj.subtaskupdate = false;
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            router.push("/choose-tasks/" + subtaskIndex + "/" + this.$route.params.task_list_id + "/null");
          },

          reorderSubtask ({oldIndex, newIndex}) {
            this.sub_tasklist_obj.subtaskupdate = true;
            const movedItem = this.sub_tasklist_obj.sub_tasklists_lists.splice(oldIndex, 1)[0];
            this.sub_tasklist_obj.sub_tasklists_lists.splice(newIndex, 0, movedItem);
            this.sub_tasklist_obj.subtask_sort_flag = true;
            setTimeout(() => {
              var j=1;
              for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
                this.sub_tasklist_obj.sub_tasklists_lists[i].sortid = 'subtask-' + j;
                var y=1;
                for(var x=0; x < this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length; x++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].sortid = 'subtask-' + j + '-heading-' + y;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].sortid = 'subtask-' + j + '-heading-' + y + '-task-' + d;
                    d++;
                  }
                  y++;
                }
                var b=1;
                for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].sortid = 'subtask-' + j + '-task-' + b;
                  b++;
                }
                j++;
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }, 1000);
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          reorderSubtaskHeading (event) {
            this.sub_tasklist_obj.subtaskupdate = true;
            var from_index = event.from.attributes[1].value;
            var to_index = event.to.attributes[1].value;
            if(from_index === to_index) {
              var parent_index = event.from.attributes[1].value;
              const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[parent_index].headings.splice(event.oldIndex, 1)[0];
              this.sub_tasklist_obj.sub_tasklists_lists[parent_index].headings.splice(event.newIndex, 0, movedItem);
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[parent_index].id);
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    d++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else {
              if (this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].update == true) {
                this.sub_tasklist_obj.remove_headings.push({
                  heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[event.oldIndex].id,
                });
              }
              const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.splice(event.oldIndex, 1)[0];
              var movedFromTaskCount = movedItem.tasks.length;
              if(movedFromTaskCount > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[from_index].tasks_count) - parseInt(movedFromTaskCount));
              }
              if(movedItem.update === true) {
                movedItem.id = '';
                movedItem.update = false;
                movedItem.modified = false;
              }
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_index].id);
              this.sub_tasklist_obj.subtaskheading_sort_subtaskId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_index].id);
              this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.splice(event.newIndex, 0, movedItem);
              var movedToTaskCount = this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[event.newIndex].tasks.length;
              if(movedToTaskCount > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[to_index].tasks_count) + parseInt(movedToTaskCount));
              }
              if(this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length == 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].addHeadingButtonShow = true;
                this.sub_tasklist_obj.sub_tasklists_lists[from_index].addTaskButtonShow = true;
              }
              if(this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.length > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].addHeadingButtonShow = true;
                this.sub_tasklist_obj.sub_tasklists_lists[to_index].addTaskButtonShow = false;
              }
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    if(event.newIndex == i) {
                      this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].update = false;
                      this.sub_tasklist_obj.sub_tasklists_lists[to_index].headings[i].tasks[c].modified = false;
                    }
                    d++;
                  }
                  j++;
                }
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_index].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_index].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    d++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
            }
            this.calculateTaskListsSummary();
            this.$store.dispatch('subtasks', this.sub_tasklist_obj);
          },
          reorderSubtaskTask (event) {
            this.sub_tasklist_obj.subtaskupdate = true;
            var from_index = event.from.attributes[1].value;
            var from_index_array = from_index.split("-");
            var from_subtask_index = from_index_array[0];
            var from_heading_index = from_index_array[1];
            var to_index = event.to.attributes[1].value;
            var to_index_array = to_index.split("-");
            var to_subtask_index = to_index_array[0];
            var to_heading_index = to_index_array[1];
            if(from_index === to_index) {
              if(from_heading_index == 'null') {
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.splice(event.oldIndex, 1)[0];
                this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].id);
              }
              else {
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.splice(event.oldIndex, 1)[0];
                this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id);
              }
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else {
              this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks_count) - parseInt(1));
              this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks_count) + parseInt(1));
              if((from_heading_index == 'null') && (to_heading_index == 'null')) {
                if (this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[event.oldIndex].update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].id,
                    task_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[event.oldIndex].id,
                  });
                }
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.splice(event.oldIndex, 1)[0];
                movedItem.update = false;
                movedItem.modified = false;
                this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].id);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].id);
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                if(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.length == 0) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].addHeadingButtonShow = true;
                  this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].addTaskButtonShow = true;
                }
                if(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.length > 0) {
                  this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].addHeadingButtonShow = false;
                  this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].addTaskButtonShow = true;
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  var to_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks[i].sortid = to_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              else if((from_heading_index == 'null') && (to_heading_index != 'null')) {
                if (this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[event.oldIndex].update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].id,
                    task_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[event.oldIndex].id,
                  });
                }
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.splice(event.oldIndex, 1)[0];
                movedItem.update = false;
                movedItem.modified = false;
                this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].id);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].id);
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                if(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.length == 0) {
                  this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].addHeadingButtonShow = true;
                  this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].addTaskButtonShow = true;
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  var to_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks[i].sortid = to_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              else if((from_heading_index != 'null') && (to_heading_index != 'null')) {
                if (this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[event.oldIndex].update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id,
                    task_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[event.oldIndex].id,
                  });
                }
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.splice(event.oldIndex, 1)[0];
                movedItem.update = false;
                movedItem.modified = false;
                this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].id);
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  var to_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].headings[to_heading_index].tasks[i].sortid = to_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              else if((from_heading_index != 'null') && (to_heading_index == 'null')) {
                if (this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[event.oldIndex].update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id,
                    task_id: this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[event.oldIndex].id,
                  });
                }
                const movedItem = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.splice(event.oldIndex, 1)[0];
                movedItem.update = false;
                movedItem.modified = false;
                this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.splice(event.newIndex, 0, movedItem);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].id);
                this.sub_tasklist_obj.headingtask_sort_headingId.push(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].id);
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                if(this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.length > 0) {
                  this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].addHeadingButtonShow = false;
                  this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].addTaskButtonShow = true;
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[from_subtask_index].headings[from_heading_index].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  var to_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[to_subtask_index].tasks[i].sortid = to_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
            }
            this.calculateTaskListsSummary();
          },
          createHeaderGroupArray: function() {
            var group_list = [];
            for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
              if((this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length > 0) && (this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length == 0)) {
                group_list.push('subtask-' + i);
              }
            }
            return group_list;
          },
          createTaskGroupArray: function() {
            var group_list = [];
            for(var i=0; i < this.$store.state.sub_tasks.sub_tasklists_lists.length; i++) {
              for(var j=0; j < this.$store.state.sub_tasks.sub_tasklists_lists[i].headings.length; j++) {
                group_list.push('heading-' + i + '-' + j);
              }
              if((this.$store.state.sub_tasks.sub_tasklists_lists[i].headings.length == 0)) {
                group_list.push('task-' + i);
              }
            }
            return group_list;
          },
          deleteSubTaskConfirm: function(subTaskIndex) {
            this.deleteMessage = 'Are you sure you want to delete? This will delete the sub task and the related headings and tasks.';
            this.subtaskIndexValue = subTaskIndex;
            this.deleteList = 'SubTask';
            this.isModalVisible = true;
          },
          deleteHeadingConfirm: function(subTaskIndex, headingIndex) {
            this.deleteMessage = 'Are you sure you want to delete? This will delete the header and the related tasks.';
            this.subtaskIndexValue = subTaskIndex;
            this.headingIndexValue = headingIndex;
            this.deleteList = 'Heading';
            this.isModalVisible = true;
          },
          deleteTaskConfirm: function(subTaskIndex, headingIndex, taskIndex) {
            this.subtaskIndexValue = subTaskIndex;
            this.headingIndexValue = headingIndex;
            this.taskIndexValue = taskIndex;

            if(this.headingIndexValue === 'null') {
              var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks[this.taskIndexValue];
            }
            else {
              var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks[this.taskIndexValue];
            }
            axios('/check-assessmentcnt-tasks/' + this.$route.params.task_list_id +'/'+ remove_data.id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
               var assessmentCount = resp.data[0].totalAssessment;
               if(assessmentCount == 0) {
                 this.deleteMessage = 'Are you sure you want to delete the task?';
                 this.deleteList = 'Task';
                 this.isModalVisible = true;
               }
               else {
                 this.validationMessage = "The task shouldn't be removed because it has assessments.";
                 this.isValidationModalVisible = true;
                 return false;
               }
             })
             .catch(error => {

             })
          },

          deleteAction: function() {
            this.sub_tasklist_obj.subtaskupdate = true;
            if(this.deleteList == 'SubTask') {
              var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue];
              if(remove_data.update == true) {
                this.sub_tasklist_obj.remove_subtask.push({
                  subtask_id: remove_data.id,
                });
                this.sub_tasklist_obj.sub_tasklists_lists.splice(this.subtaskIndexValue, 1);
              }
              else {
                this.sub_tasklist_obj.sub_tasklists_lists.splice(this.subtaskIndexValue, 1);
              }
              setTimeout(() => {
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[i].sortid = 'subtask-' + j;
                  var y=1;
                  for(var x=0; x < this.sub_tasklist_obj.sub_tasklists_lists[i].headings.length; x++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].sortid = 'subtask-' + j + '-heading-' + y;
                    var d=1;
                    for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks.length; c++) {
                      this.sub_tasklist_obj.sub_tasklists_lists[i].headings[x].tasks[c].sortid = 'subtask-' + j + '-heading-' + y + '-task-' + d;
                      d++;
                    }
                    y++;
                  }
                  var b=1;
                  for(var a=0; a < this.sub_tasklist_obj.sub_tasklists_lists[i].tasks.length; a++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[i].tasks[a].sortid = 'subtask-' + j + '-task-' + b;
                    b++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else if(this.deleteList == 'Heading') {
              var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue];
              var deleted_tasks_count = remove_data.tasks.length;
              if(deleted_tasks_count > 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks_count) - parseInt(deleted_tasks_count));
              }
              if(remove_data.update == true) {
                this.sub_tasklist_obj.remove_headings.push({
                  heading_id: remove_data.id,
                });
                this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings.splice(this.headingIndexValue, 1);
              }
              else {
                this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings.splice(this.headingIndexValue, 1);
              }
              if(this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings.length === 0) {
                this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].addHeadingButtonShow = true;
                this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].addTaskButtonShow = true;
              }
              setTimeout(() => {
                var parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].sortid;
                var j=1;
                for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings.length; i++) {
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[i].sortid = parent_sortid + '-heading-' + j;
                  var d=1;
                  for(var c=0; c < this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[i].tasks.length; c++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[i].tasks[c].sortid = parent_sortid + '-heading-' + j + '-task-' + d;
                    d++;
                  }
                  j++;
                }
                this.$store.dispatch('subtasks', this.sub_tasklist_obj);
              }, 1000);
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
            else if(this.deleteList == 'Task') {
              this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks_count = (parseInt(this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks_count) - parseInt(1));
              if(this.headingIndexValue === 'null') {
                var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks[this.taskIndexValue];
                if(remove_data.update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].id,
                    task_id: remove_data.id,
                  });
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                else {
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                if(this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks.length === 0) {
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].addHeadingButtonShow = true;
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].addTaskButtonShow = true;
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.calculateTaskListsSummary();
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              else {
                var remove_data = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks[this.taskIndexValue];
                if(remove_data.update == true) {
                  this.sub_tasklist_obj.remove_tasks.push({
                    heading_id: this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].id,
                    task_id: remove_data.id,
                  });
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                else {
                  this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks.splice(this.taskIndexValue, 1);
                }
                setTimeout(() => {
                  var from_parent_sortid = this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].sortid;
                  var j=1;
                  for(var i=0; i < this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks.length; i++) {
                    this.sub_tasklist_obj.sub_tasklists_lists[this.subtaskIndexValue].headings[this.headingIndexValue].tasks[i].sortid = from_parent_sortid + '-task-' + j;
                    j++;
                  }
                  this.$store.dispatch('subtasks', this.sub_tasklist_obj);
                }, 1000);
              }
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            }
          },

          navigate(pathUrl) {
            router.go({
              path: pathUrl,
              force: true
            });
          },
          loadSubTaskListsAction: function(task_list_id) {
            this.$store.dispatch('subtasks', '');
            this.sub_tasklist_obj.sub_tasklists_lists = '';
            axios('/sub-tasklists/' + task_list_id,
              {
                method: 'GET',
              }
            )
            .then(resp => {
              this.loading = false;
              this.sub_tasklist_obj.sub_tasklists_lists = resp.data.sub_tasklists;
              this.sub_tasklist_obj.tasklist = resp.data.tasklist;
              this.sub_tasklist_obj.subtaskupdate = resp.data.subtaskupdate;
              this.calculateTaskListsSummary();
              this.$store.dispatch('subtasks', this.sub_tasklist_obj);
            })
            .catch(error => {
              this.loading = false;
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
              else if(error.response.data.code == '404') {
                router.push("/view-tasklist");
              }
            })
          },
          fetchAffiliateOptions: function() {
            axios.get('/affiliateoptions', {

            })
            .then((response) => {
                var affiliate_option = {value: '', text: 'Select Affiliate'};
                this.affiliate_options.push(affiliate_option);
                for(var i=0; i < response.data.length; i++) {
                  var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                  this.affiliate_options.push(affiliate_option);
                }
            })
            .catch(error => {

            });

          },
          unload($event) {
            if (!this.changed()) return true;
          	var confirmationMessage = "\o/";
            $event.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
            return confirmationMessage;              // Gecko, WebKit, Chrome <34
          },
          changed() {
            if(this.sub_tasklist_obj.subtaskupdate == true) {
              this.content = "Editted";
            }
            else {
              this.content = "";
            }
            return this.content !== ''
          },
          scrollToElement(type) {
            const el = this.$el.getElementsByClassName('page_to_'+type)[0];
            if (el) {
              el.scrollIntoView({behavior: 'smooth'});
            }
          }
        },
        beforeRouteLeave(to, from, next) {
          if (this.changed() && !confirm('Changes that you made to the task list is not saved. Please save before leaving.'))
            next(false)
          else
            next()
        },
        beforeMount() {
        	window.addEventListener('beforeunload', this.unload)
        },
        beforeDestroy() {
        	window.removeEventListener('beforeunload', this.unload)
        },
        created: function () {
          this.loading = true;

          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
            this.admin = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
          if(this.$store.state.sub_tasks) {
            this.sub_tasklist_obj = this.$store.state.sub_tasks;
          }
          else {
            this.loadSubTaskListsAction(this.$route.params.task_list_id);
          }
          this.calculateTaskListsSummary();
          if((this.masterAdmin === true) && ((!this.$store.state.switch_admin_username) || (this.$store.state.switch_admin_username == ''))) {
           this.fetchAffiliateOptions();
          }
          if((this.$store.state.tasklist_title) && (this.$store.state.tasklist_title == 'Edit')) {
            this.pageHeading = 'Edit Task List';
          }
          else {
            this.pageHeading = 'New Task List';
          }
        }
}
</script>

<style scoped>

  .margin-top-10 {
    margin-top: 10px;
  }
  .margin-left-20 {
    margin-left: 0px;
  }
  ul .list-group-item {
    padding: 0;
  }
  .subtask_list li {
    background: none;
    border: 0px;
  }
  .subtask_list li .subtask_item, .subtaskadd {
    background: #FFF;
    padding: 5px 15px;
    margin-bottom: 5px;
  }
  .heading_container {
    padding-left: 30px;
  }
  .task_container {
    background: #FFF;
    line-height: 20px;
  }
  .task_container_padding {
    padding: 5px 15px 5px 30px;
  }
  .subtask_task_container {
    padding-left: 30px;
  }
  .subtask_task_container {
    background: #FFF;
    margin-left: 30px;
  }
  .subtask_task_container_padding {
    padding: 5px 15px;
  }
  .subtask_task_container_padding2 {
    padding: 1px 15px;
  }
  .heading_list li .heading_item, .headingadd {
    background: #D4D4D4;
    padding: 5px 15px 5px 15px;
    margin-bottom: 0px;
  }
  .save-button-width {
    width: 87px;
  }
  .task_item{
    line-height: 30px;
  }
  .margin-bottom-0 {
    margin-bottom: 0px !important;
  }
  .backgroud-none {
    background: none;
  }
  .createBtn {
    margin: 10px 0 3px 5px;
  }
  .form_row { width: 100%; display: flex; flex-wrap: wrap; padding: 0px; }
  .form_col_1 { width: 90%; margin-top: 10px; }
  .form_col_2 { width: 10%; margin-top: 5px; text-align: right; }
  .scroll_box {
    padding: 0;
    display: flex;
    justify-content: end;
  }
  .scroll_up_down {
    background-color: #efac91;
    padding: 5px;
    text-align: center;
    width: 40px;
  }
  .angle_font {
    color: #FFF !important;
    font-size: 1.8rem !important;
  }
</style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
.default-hours-height {
  line-height: 17px;
  border-radius: 5px;
  padding-left: 5px !important;
  border: 1px solid #707070;

}
.readonly {
  background-color: rgba(239, 239, 239, 0.3);
}
.task-list-summary {
  font-size: 18px;
  font-weight: bold;
  padding-top: 5px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/create_sub_tasklists.vue